import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changeset from 'ember-changeset/helpers/changeset';
import add from 'ember-math-helpers/helpers/add';
import type { ModelListItem } from 'parog-web/components/model-list';
import DatePicker from '../../../changeset/date-picker';

interface Signature {
  Args: {
    item: ModelListItem;
    changeset: EmberChangeset;
  };
}

export default class TreatmentHistoryEditionFormOncoBreastCancerFormImmunotherapySectionBreastCancer extends Component<Signature> {
  get #immunotherapies() {
    return this.args.changeset.get('immunotherapies');
  }

  onChangesetUpdate = (changeset: EmberChangeset) => {
    changeset.execute();
    this.#setAsDirty();
  };

  #setAsDirty() {
    this.args.changeset.set(
      'immunotherapies',
      [].concat(this.#immunotherapies)
    );
  }

  <template>
    <div class='ui segment' data-test-immunotherapy-list-item={{@item.index}}>
      {{#let (changeset @item.item) as |immunotherapyChangeset|}}

        <h3 class='ui dividing header'>Immunothérapie
          {{add @item.index 1}}</h3>
        <div class='absolute right-0 top-0 mr-2 mt-4'>
          <i class='trash icon' role='button' {{on 'click' @item.destroy}}>
          </i>
        </div>
        <div>
          <div class='field'>
            <DatePicker
              @labelName="Consultation d'immunothérapie"
              @propertyName='consultation'
              @changeset={{immunotherapyChangeset}}
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
          <div class='field'>
            <DatePicker
              @labelName='Date de début'
              @propertyName='startDate'
              @changeset={{immunotherapyChangeset}}
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
          <div class='field'>
            <DatePicker
              @labelName='Date de fin'
              @propertyName='endDate'
              @changeset={{immunotherapyChangeset}}
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
        </div>
      {{/let}}
    </div>
  </template>
}
